

































import Vue from 'vue'
import { IFacility, IFacilityDTO } from '@zunta/configurations'
import Component from 'vue-class-component'
import ScrollView from '@/components/ScrollView.vue'
import Switcher from '@/components/Switcher.vue'
import SearchInput from '@/components/inputs/SearchInput.vue'
import { getModule } from 'vuex-module-decorators'
import { FacilityModule } from '@/store/modules/facility.module'
import { NoCache } from '@/decorators/NoCache'
import Card from '@/components/Card.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'

@Component({
  components: {
    Card,
    SearchInput,
    Switcher,
    ScrollView,
    Checkbox
  }
})
export default class FacilityImport extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  selectAll: boolean = true
  selectedFacilities: string[] = []
  searchValue: string = ''
  isImporting: boolean = false

  @NoCache
  get importFacilitiesList () {
    if (this.searchValue) {
      return this.$store.state.facility.facilitiesForImport.filter((facilityData: { name: string, originId: string }) => {
        return facilityData.name.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
      })
    }
    return this.$store.state.facility.facilitiesForImport
  }

  get facilitiesList () {
    return this.$store.state.facility.facilities
  }

  @NoCache
  get isImported () {
    return this.$store.state.facility.isImported
  }

  get isNewFacilitiesSelected (): boolean {
    // return this.selectedFacilities.findIndex((selectedFacility: any) =>
    //     this.facilitiesList.findIndex((item: any) => item.originid === selectedFacility && item.zuntaLicensePdf) > -1) > -1

    let isNewFacilitySelected = false
    for (const selectedFacility of this.selectedFacilities) {
      const facilityFound =
        this.facilitiesList.findIndex((item: any) => item.originid === selectedFacility && item.zuntaLicensePdf) > -1
      if (!facilityFound) {
        isNewFacilitySelected = true
        break
      }
    }
    return isNewFacilitySelected
  }

  selectAllFacilities (selectAll: boolean = true) {
    this.selectedFacilities = selectAll 
      ? this.importFacilitiesList.map((facility: IFacilityDTO) => facility.originId as string)
      : [] 
  }
  
  async mounted () {
    if (this.$store.state.facility.facilitiesForImport.length !== 0) {
      await this.facilityModuleInstance.getFacilityList({})
      this.selectAllFacilities()
    } else {
      this.$router.push({ name: 'management-facilities-login' })
    }
  }

  public isSelected (facility: IFacilityDTO): boolean {
    if (facility.originId) {
      return this.selectedFacilities.indexOf(facility.originId) !== -1
    }
    return false
  }

  public async onImportFacilities (): Promise<void> {
    if (!this.selectedFacilities.length) {
      return
    }
    this.facilityModuleInstance.setSelectedFacilitiesForImport(this.selectedFacilities)
    if (this.isNewFacilitiesSelected) {
      const facilities = this.importFacilitiesList.filter((facilityDTO: { name: string, originId: string }) => {
        const existsFacility = this.facilitiesList.find((facilityItem: IFacility) => facilityItem.originid === facilityDTO.originId)
        return facilityDTO.originId && this.selectedFacilities.includes(facilityDTO.originId) && (!existsFacility || !existsFacility.zuntaLicensePdf)
      })

      this.$router.push({
        name: 'management-facilities-agreements',
        query: {
          facilities: (window as any).encodeURIComponent(JSON.stringify(facilities))
        }
      })
    } else {
      this.$eventBus.$emit('loading:enable', { message: 'Importing Facilities' })
      this.isImporting = true
      await this.facilityModuleInstance.importSelectedFacilities()
      this.isImporting = false
      this.$eventBus.$emit('loading:disable')
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: 'Facilities are fetching and will be available within 2-10 minutes.',
        header: `Import Facilities`,
        icon: 'check'
      })
      this.$router.push({ name: 'management-facilities' })
    }
  }

  toggleFacility (facility: IFacilityDTO, active: boolean) {
    if (!facility.originId) {
      return
    }

    if (active) {
      this.selectedFacilities.push(facility.originId)
    } else {
      const index = this.selectedFacilities.indexOf(facility.originId)
      this.selectedFacilities.splice(index, 1)
    }
  }
}
